import { Box, Center } from '@chakra-ui/react';
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext';
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel';
import { StartupsUnlimitedAccounts } from '@src/components/sco/Account/StartupsUnlimitedAccounts';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { AccountPage } from '@src/layouts/AccountPageLayout';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default AccountPage(function () {
  const accountContext = useAccountContext();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    activeContent.setSiteSection('account.startups-unlimited');
  });
  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([{
      title: 'Account',
      href: '/account'
    }, {
      title: 'Startups Unlimited',
      href: '/account/startups-unlimited'
    }]);
  }, []);
  return <AccountMainPanel>
      <Center minHeight={'80vh'} padding={'1em'}>
        <Box maxWidth={'1200px'} width={'full'}>
          <SSRGate disableSSR={true}>
            <StartupsUnlimitedAccounts />
          </SSRGate>
        </Box>
      </Center>
    </AccountMainPanel>;
});